import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-user',
  templateUrl: './maintenance-user.component.html',
  styleUrls: ['./maintenance-user.component.sass']
})
export class MaintenanceUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
